var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4918 1.27126C19.2702 -1.15346 11.7153 -0.0931348 6.6554 4.35088C2.60121 7.94508 -0.228933 13.1843 0.0673354 18.7043C-0.478421 24.5517 2.36731 29.9937 5.92253 34.4143C7.41946 31.2099 9.85978 28.5669 13.0564 27.0154C9.60249 23.5459 8.51877 17.527 12.2611 13.847C16.2451 9.07558 24.6654 10.7596 26.8016 16.4979C28.587 20.1311 26.8328 24.193 24.2366 26.914C27.4409 28.6994 30.0372 31.3269 31.8772 34.4923C31.9841 34.3168 32.0913 34.1413 32.1985 33.9656C34.1165 30.8241 36.0589 27.6428 37.0852 24.0839C39.5567 15.0477 34.4032 4.46783 25.4918 1.27126ZM14.5345 34.2245C14.022 37.1877 13.5097 40.1506 12.8694 43.0898C13.5155 43.6486 14.1158 44.3072 14.7191 44.9691C15.8919 46.2559 17.0762 47.5552 18.631 48.1576C20.2536 47.5709 21.4606 46.1996 22.6527 44.8451C23.2191 44.2016 23.7822 43.5618 24.3849 43.0119C23.898 40.6021 23.4654 38.1828 23.0329 35.764C22.5096 32.8378 21.9865 29.9123 21.3676 27.0056C19.5276 27.0056 17.6954 27.0056 15.8555 26.9978C15.369 29.3984 14.9517 31.8115 14.5345 34.2245Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9718469d85e1db65280e5c926ba664ee.svg";
export { ForwardRef as ReactComponent };